import { useState } from "react";
import {
  Grid,
  Tooltip,
  CurrencyInput,
  TextFielDecimalNumbers,
  ModalPrecificacao,
  Button,
} from "../../../../components";
import { SessionService } from "../../../../services";

const FormPrecoCusto = ({
  id,
  produto,
  inputErros,
  handleInputChangeVenda,
  configuracoes,
  setPrecificacaoPending,
}) => {
  const [openDialogPrecificao, setOpenDialogPrecificao] = useState(false);
  const sessionService = new SessionService();
  const dadosEmpresa = sessionService.getEmpresa();

  const nextFocusInput = (event) => {
    let inputCount = 2;
    if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
      const { form } = event.target;
      const index = Array.from(form.elements).indexOf(event.target);
      let element = form.elements[index + inputCount];
      if (element?.disabled) {
        element = form.elements[index + inputCount + 2];
      }
      if (element) {
        element.focus();
      }
      event.preventDefault();
    }
  };

  return (
    <form>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={2}>
          <CurrencyInput
            id="precoCompra"
            name="precoCompra"
            label="Preço Compra"
            disabled={produto.tipo.id === "kit" ? true : false}
            error={inputErros.get("precoCompra")}
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto.precoCompra ?? ""}
            onBlur={handleInputChangeVenda}
            required
          />
        </Grid>
        <Grid item xs={2}>
          <Tooltip
            title={
              <>
                Preço de custo deve ser igual ou
                <br />
                maior que o preço de compra
              </>
            }
            arrow
            placement="bottom"
            enterTouchDelay={0}
            enterDelay={500}
          >
            <CurrencyInput
              id="precoCusto"
              name="precoCusto"
              label="Preço Custo"
              required
              value={produto.precoCusto ?? ""}
              onKeyDown={(e) => nextFocusInput(e)}
              onBlur={handleInputChangeVenda}
            />
          </Tooltip>
        </Grid>
        <Grid item xs={1.75}>
          <CurrencyInput
            id="precoMedio"
            name="precoMedio"
            label="Preço Médio"
            disabled={true}
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto.precoMedio ?? ""}
            onBlur={handleInputChangeVenda}
          />
        </Grid>
        <Grid item xs={1.75}>
          <TextFielDecimalNumbers
            id="comissao"
            name="comissao"
            label="Comissão"
            variant="outlined"
            onKeyDown={(e) => nextFocusInput(e)}
            value={produto.comissao ?? ""}
            onBlur={handleInputChangeVenda}
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <Tooltip
            title={
              <>
                Lucro deve ser menor que 100%
                <br />
                em cálculo de margem inversa (MI)
              </>
            }
            arrow
            placement="bottom"
            enterTouchDelay={0}
            enterDelay={500}
          >
            <TextFielDecimalNumbers
              id="lucroDesejado"
              name="lucroDesejado"
              label="Lucro Desejado"
              variant="outlined"
              onKeyDown={(e) => nextFocusInput(e)}
              InputProps={{
                inputProps: {
                  max:
                    configuracoes?.margemCalculo === "CONVENCIONAL" && 100000,
                },
              }}
              value={produto.lucroDesejado ?? ""}
              onBlur={handleInputChangeVenda}
              fullWidth
            />
          </Tooltip>
        </Grid>
        <Grid item xs={2}>
          <CurrencyInput
            id="precoVenda"
            name="precoVenda"
            label="Preço Venda"
            error={inputErros.get("precoVenda")}
            value={produto.precoVenda ?? ""}
            onKeyDown={(e) => nextFocusInput(e)}
            onBlur={handleInputChangeVenda}
            required
          />
        </Grid>
        {dadosEmpresa?.moduloPrecificacao ? (
          <>
            <Grid item xs={0.5} sx={{ mt: 1 }}>
              <Tooltip title="Precificar com parametros">
                <Button
                  id="buttonAdicionar"
                  variant="contained"
                  color="success"
                  size="small"
                  sx={{
                    height: "35px",
                    borderRadius: "20%",
                    minWidth: "15px",
                    boxShadow: "none",
                  }}
                  onClick={() => setOpenDialogPrecificao(true)}
                >
                  <i
                    className="ph-bold ph-plus"
                    style={{ color: "#fff", fontSize: 15 }}
                  ></i>
                </Button>
              </Tooltip>
            </Grid>
            <ModalPrecificacao
              open={openDialogPrecificao}
              setOpen={setOpenDialogPrecificao}
              produtos={[{ ...produto, produtoId: id }]}
              handleSubmitProduto={(precificacao) => {
                if (!id) {
                  setPrecificacaoPending(precificacao);
                }
              }}
            />
          </>
        ) : null}
      </Grid>
    </form>
  );
};

export default FormPrecoCusto;
